import { useState } from 'react';
import { Link } from 'react-router';
import { useI18n } from '../../i18n';
import { Icon } from '../../ui';
import { LEGAL } from './legal';

/** The last legal change this browser was shown (a YYYY-MM-DD date). */
export const LEGAL_SEEN_KEY = 'teamfolio.legalSeen';

/**
 * "The privacy policy changed on 13 Oct 2026" on every page of the app, until it is closed (TF-255):
 * the policy promises that important changes are announced in the app. LEGAL.announced moves only for
 * those; closing remembers it in this browser. Without storage, nothing is shown rather than every time.
 */
export function LegalChangeBanner() {
  const { t, date } = useI18n();
  const [seen, setSeen] = useState(() => {
    try {
      return localStorage.getItem(LEGAL_SEEN_KEY) ?? '';
    } catch {
      return LEGAL.announced;
    }
  });
  if (seen >= LEGAL.announced) return null;
  const close = () => {
    setSeen(LEGAL.announced);
    try {
      localStorage.setItem(LEGAL_SEEN_KEY, LEGAL.announced);
    } catch {
      // Shown again on the next visit.
    }
  };
  return (
    <div className="banner banner-info" role="status" data-testid="legal-banner">
      <Icon name="verified_user" />
      <span>
        {t('legal.changed', { date: date(LEGAL.announced) })} <Link to="/privacy">{t('legal.privacy')}</Link>
        {' · '}
        <Link to="/legal/dpa">{t('legal.dpa')}</Link>
      </span>
      <button type="button" className="icon-btn banner-close" aria-label={t('common.close')} onClick={close}>
        <Icon name="close" />
      </button>
    </div>
  );
}
